
export const getName =(data,dataID) =>{
    var className = ""
    if(data!==null){
        //loop through the array
        if(data.length>0){
            data.map((values,i) =>{
                if (parseInt(values.id) === parseInt(dataID)){
                    className = values.name
                }
            });
        }
    }
    return className
}

export const getName2 =(data,dataID,action) =>{
    var className = ""
    if(data!==null){
        //loop through the array
        if(data.length>0){
            data.map((values,i) =>{
                if (parseInt(values.id) === parseInt(dataID)){
                    if(action ==="TERM"){
                        className = values.termName
                    }

                    if(action ==="YEAR"){
                        className = values.yearName
                    }
                   
                }
            });
        }
    }
    return className
}

//
export const getArraysIntersection=(a1,a2)=>{
    //returns Intersection ['a','b']
    return  a1.filter(function(n) { return a2.indexOf(n) !== -1;});
}